/**
 * One timestamp style for comments and offer history (owner, 2026-10-23):
 * "Just now", "5m ago", "3h ago", "2d ago", then "Jan 18, 2026 at 3:45 PM".
 * This is the listing-comment format that used to live inline in
 * PedalDetails; the offer pages showed "10/23/2026, 3:45 PM" instead.
 * The chat page keeps its own day separators plus a time, which is a
 * different layout rather than a different format.
 */

export function toDateSafe(timestamp) {
  if (!timestamp) return null;
  if (typeof timestamp.toDate === 'function') return timestamp.toDate();
  const d = timestamp instanceof Date ? timestamp : new Date(timestamp);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatRelativeTime(timestamp, now = new Date()) {
  const date = toDateSafe(timestamp);
  if (!date) return 'Just now';
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  const dateStr = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${dateStr} at ${timeStr}`;
}
